import { GetImagesCommand } from "@aws-sdk/client-kinesis-video-archived-media"; // ES Modules import
const MinSamplingInterval = 200;
const MaxSamplingInterval = 20000;
export const getImages = async ({ client, StreamARN, fromTimestamp, toTimestamp, dimensions = { WidthPixels: 36, HeightPixels: 36 }, MaxResults = 1, NextToken, SamplingInterval = MaxSamplingInterval }) => {
    const input = {
        StreamARN,
        ImageSelectorType: "PRODUCER_TIMESTAMP",
        StartTimestamp: new Date(fromTimestamp), // required
        EndTimestamp: new Date(toTimestamp), // required
        SamplingInterval,
        Format: "JPEG",
        FormatConfig: {
            JPEGQuality: '80'
        },
        WidthPixels: dimensions.WidthPixels,
        HeightPixels: dimensions.HeightPixels,
        MaxResults,
        NextToken,
    };
    console.log(`getImages: start before end? ${input.StartTimestamp?.getTime()} < ${input.EndTimestamp?.getTime()}`);
    const command = new GetImagesCommand(input);
    const { Images, NextToken: NextTokenOut } = await client.send(command);
    // { // GetImagesOutput
    //   Images: [ // Images
    //     { // Image
    //       TimeStamp: new Date("TIMESTAMP"),
    //       Error: "NO_MEDIA" || "MEDIA_ERROR",
    //       ImageContent: "STRING_VALUE",
    //     },
    //   ],
    //   NextToken: "STRING_VALUE",
    // };
    return { Images, NextToken: NextTokenOut };
};
